module.exports = __webpack_public_path__ + "static/media/tawuniya-logo.0f06485f.svg";